import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import {
  DEFAULT_SMER,
  isContractType,
  isSmer,
  parseMesice,
} from '@/modules/zakaznici/vyhledavani-helpers';
import type {
  CustomerSearchContractType,
  CustomerSearchSmer,
} from '@/modules/zakaznici/api';
import { Route as RootRoute } from './__root';

const ZakazniciVyhledavaniPage = lazy(() =>
  import('@/modules/zakaznici/ZakazniciVyhledavaniPage').then((m) => ({
    default: m.ZakazniciVyhledavaniPage,
  })),
);

export interface VyhledavaniSearch {
  q?: string;
  typ?: CustomerSearchContractType;
  smer?: CustomerSearchSmer;
  mesice?: number;
}

function parseVyhledavaniSearch(input: Record<string, unknown>): VyhledavaniSearch {
  const out: VyhledavaniSearch = {};
  if (typeof input.q === 'string' && input.q.trim() !== '') out.q = input.q;
  if (isContractType(input.typ) && input.typ !== 'any') out.typ = input.typ;
  if (isSmer(input.smer) && input.smer !== DEFAULT_SMER) out.smer = input.smer;
  const mesice = parseMesice(
    typeof input.mesice === 'string' || typeof input.mesice === 'number' ? input.mesice : null,
  );
  if (mesice != null) out.mesice = mesice;
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici/vyhledavani',
  component: () => (
    <Suspense fallback={null}>
      <ZakazniciVyhledavaniPage />
    </Suspense>
  ),
  validateSearch: parseVyhledavaniSearch,
});
